var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasicSavingsIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 385,
    viewBox: "0 0 600 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M472 103H148C132.536 103 120 115.536 120 131V305C120 320.464 132.536 333 148 333H472C487.464 333 500 320.464 500 305V131C500 115.536 487.464 103 472 103Z",
    stroke: "#132A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M120 131C120 112.333 129.333 103 148 103H420C453.333 103 470 119.667 470 153V183C470 196.333 463.333 203 450 203H260C246.667 203 240 196.333 240 183V153C240 138.333 233.333 131 220 131H120Z",
    stroke: "#132A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M150 273H470",
    stroke: "#132A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M332 223H168C163.582 223 160 226.582 160 231V251C160 255.418 163.582 259 168 259H332C336.418 259 340 255.418 340 251V231C340 226.582 336.418 223 332 223Z",
    stroke: "#132A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M450 232C457.732 232 464 225.732 464 218C464 210.268 457.732 204 450 204C442.268 204 436 210.268 436 218C436 225.732 442.268 232 450 232Z",
    stroke: "#132A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M450 224C453.314 224 456 221.314 456 218C456 214.686 453.314 212 450 212C446.686 212 444 214.686 444 218C444 221.314 446.686 224 450 224Z",
    stroke: "#132A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M160 107C178.778 107 194 91.7777 194 73C194 54.2223 178.778 39 160 39C141.222 39 126 54.2223 126 73C126 91.7777 141.222 107 160 107Z",
    stroke: "#132A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M160 95C172.15 95 182 85.1503 182 73C182 60.8497 172.15 51 160 51C147.85 51 138 60.8497 138 73C138 85.1503 147.85 95 160 95Z",
    stroke: "#132A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M152 73H168M160 65V81",
    stroke: "#132A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M225 67C237.15 67 247 57.1503 247 45C247 32.8497 237.15 23 225 23C212.85 23 203 32.8497 203 45C203 57.1503 212.85 67 225 67Z",
    stroke: "#132A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M225 58C232.18 58 238 52.1797 238 45C238 37.8203 232.18 32 225 32C217.82 32 212 37.8203 212 45C212 52.1797 217.82 58 225 58Z",
    stroke: "#132A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M205 23C195 3 180 -3.66667 160 3",
    stroke: "#132A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M90 363H530",
    stroke: "#132A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicSavingsIllustration);
export default __webpack_public_path__ + "static/media/basic-savings-illustration.2a603aedf7be8626b7ac675f80a18bf4.svg";
export { ForwardRef as ReactComponent };